import { takeLatest, select, put, call } from 'redux-saga/effects'
import { setQueueFilterInput, setFilteredTasks } from 'store/actions';
import { queueBinsStateSelector } from 'store/selectors';
import { getChipStatus } from 'components/layout/OpportunityStatusChip';
import { getChipStatus as getPostAcqChipStatus } from 'components/underwrite/postAcquisition/TaskStatusChip';

// eslint-disable-next-line require-yield
function* getFilteredTaskIds(queueBinsState, inputString) {
  let filteredTaskIds = [];
  if (inputString.length > 0) {
    const { tasks = [] } = queueBinsState?.allTasks;
    tasks.forEach(task => {
      let isFoundSearchValue = false;

      if (task.taskType === 'txnOpp') {
        const flattenHome = [
          `${getChipStatus(task)?.text}`,
          `${task.street}`,
          `${task.importName}`,
          `${task.sqft?.toLocaleString() || ''}`,
          `${task.beds}`,
          `${task.baths}`,
          `${task.id}`,
          `${task.city}, ${task.state} ${task.zipCode}`
        ];

        flattenHome.forEach(item => {
          if (item.toLowerCase().includes(inputString.toLowerCase())) {
            isFoundSearchValue = true;
          }
        });
      } else if (task.taskType === 'postAcqTask') {
        const flattenTask = [
          `${getPostAcqChipStatus(task)?.text}`,
          `${task.street}`,
          `${task.channel}`,
          `${task.stage}`,
          `${task.requestType ?? ''}`,
          `${task.sqft?.toLocaleString() || ''}`,
          `${task.beds}`,
          `${task.baths}`,
          `${task.id}`,
          `${task.city}, ${task.state} ${task.zipCode}`
        ];

        flattenTask.forEach(item => {
          if (item.toLowerCase().includes(inputString.toLowerCase())) {
            isFoundSearchValue = true;
          }
        });
      }

      if (isFoundSearchValue) {
        filteredTaskIds.push(task.id);
      }
    });
  }

  return filteredTaskIds;
}
const getAllTaskIds = (queueBinsState) => {
  let allTaskIds = [];
  Object.values(queueBinsState).forEach(bin =>
    bin.tasks.forEach(task => allTaskIds.push(task.id)));
  return allTaskIds;
}

export function* setQueueFilterInputSaga() {
  yield takeLatest(setQueueFilterInput, function* ({ payload }) {
    const { module, queueFilterInput } = payload;
    const queueBinsState = yield select(queueBinsStateSelector, module);

    if (queueBinsState !== null) {
      if (queueFilterInput !== '') {
        let filteredTaskIds = yield call(getFilteredTaskIds, queueBinsState, queueFilterInput);
        if (filteredTaskIds.length > 0) {
          yield put(setFilteredTasks(module, filteredTaskIds));
        } else {
          yield put(setFilteredTasks(module, []));
        }
      } else {
        let allTasks = getAllTaskIds(queueBinsState);
        yield put(setFilteredTasks(module, allTasks));
      }
    } else {
      console.log('queueBinsState is null in setQueueFilterInputSaga');
    }
  });
}

